import {
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";

import * as formik from "formik";
import * as yup from "yup";

const WHATSAPP_NUMBER = "51904340591";

export const ContactForm = () => {
  const { t } = useTranslation();

  const buildWhatsAppUrl = (values) => {
    const message = [
      t("contactForm.whatsapp.greeting"),
      ``,
      t("contactForm.whatsapp.intro"),
      ``,
      `${t("contactForm.whatsapp.nameLabel")} ${values.name}`,
      `${t("contactForm.whatsapp.emailLabel")} ${values.email}`,
      ``,
      t("contactForm.whatsapp.messageLabel"),
      values.message,
      ``,
      t("contactForm.whatsapp.closing"),
    ].join("\n");

    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  };

  const { Formik } = formik;

  const schema = yup.object().shape({
    name: yup.string().required(t("contactForm.validation.required")),
    email: yup
      .string()
      .email(t("contactForm.validation.email"))
      .required(t("contactForm.validation.required")),
    message: yup
      .string()
      .required(t("contactForm.validation.required"))
      .min(6, t("contactForm.validation.minMessage")),
  });

  return (
    <div className="contact-box">
      <Formik
        validationSchema={schema}
        onSubmit={(values, { resetForm }) => {
          window.open(buildWhatsAppUrl(values), "_blank");
          resetForm();
        }}
        initialValues={{
          name: "",
          email: "",
          message: "",
        }}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group
                as={Col}
                xs="12"
                md="6"
                controlId="validationFormik01"
              >
                <Form.Label>{t("contactForm.name.label")}</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder={t("contactForm.name.placeholder")}
                  value={values.name}
                  onChange={handleChange}
                  isInvalid={touched.name && !!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                xs="12"
                md="6"
                controlId="validationFormik02"
                className={"mt-3 mt-md-0"}
              >
                <Form.Label>{t("contactForm.email.label")}</Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  placeholder={t("contactForm.email.placeholder")}
                  value={values.email}
                  onChange={handleChange}
                  isInvalid={touched.email && !!errors.email}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} xs="12" controlId="validationFormik03">
                <Form.Label>{t("contactForm.message.label")}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("contactForm.message.placeholder")}
                  name="message"
                  value={values.message}
                  onChange={handleChange}
                  isInvalid={touched.message && !!errors.message}
                  as="textarea"
                  rows={6}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Button className="card-effect__button" type="submit">
              {t("contactForm.submit")}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};
